import clsx from 'clsx';
import React, { useMemo, useState } from 'react';

import { TextButton } from '@components/Button/variants';
import IconArrowDown from '@components/Images/Rebranding/IconArrowDown';
import { Member, TeamGroupProps } from '@utils/aboutInterfaces';

import Employee from './Employee';

const Group = ({ canSendMessage, group, setMessageUser }: TeamGroupProps) => {
  const [isActive, setActive] = useState(false);
  const twoColumns: Member[][] = useMemo(() => {
    const columns = [[], []];
    group.members.forEach((member, idx) => {
      columns[idx % 2].push(member);
    });
    return columns;
  }, [group.members]);

  return (
    <div className="border-0 border-b border-solid border-grayscale-beige py-48">
      <TextButton
        as="button"
        className="flex w-full items-center justify-between px-0 no-underline hover:!text-grayscale-charcoal focus:text-grayscale-charcoal"
        onClick={() => setActive(!isActive)}
        data-test="Group"
      >
        <h3 className="my-0 font-suisse-intl-mono text-caption-lg">{group.name}</h3>
        <div>
          <IconArrowDown
            className={clsx(
              'w-[26px] -rotate-90 transform fill-primary-magenta transition-transform',
              {
                'rotate-0': isActive,
              }
            )}
          />
        </div>
      </TextButton>
      {isActive && (
        <div className="m-auto inline-flex w-full flex-wrap items-start justify-center gap-x-16 sm:flex-nowrap">
          <div className="flex w-full flex-col sm:w-[348px] md:w-[424px]">
            {twoColumns[0].map((member, idx) => (
              <Employee
                key={idx}
                member={member}
                onMessage={() => setMessageUser({ id: member.userId, name: member.name })}
                canSendMessage={canSendMessage}
              />
            ))}
          </div>
          <div className="flex  w-full flex-col sm:w-[348px] md:w-[424px]">
            {twoColumns[1].map((member, idx) => (
              <Employee
                key={idx}
                member={member}
                onMessage={() => setMessageUser({ id: member.userId, name: member.name })}
                canSendMessage={canSendMessage}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Group;
